import * as React from 'react';
import { LProps, withLocalization } from '../../utils/wrappers';
import { compose, Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { State } from '../../redux/state';
import { RouterProps, withRouter } from 'react-router';
import actions from '../../redux/actions';
import { asPage } from '../../utils/wrappers/asPage';
import PledgesTable from '../../shared/PledgesTable';
import PledgesCards from '../../shared/PledgesCards';
import { ButtonGroup, Button } from 'reactstrap';

interface Props {
  initializePledgesPage: () => void;
}

interface PledgeViewSelectionProps {
  layout: 'cards' | 'table';
}

interface PledgeViewSelectionHandlersProps {
  onLayoutChange: (layout: 'cards' | 'table') => void;
}

class PledgeViewSelection extends React.Component<LProps<PledgeViewSelectionProps & PledgeViewSelectionHandlersProps>> {

  public render() {
    const { t, layout } = this.props;
    return (
      <ButtonGroup>
        <Button
          color={layout === 'cards' ? 'primary' : 'secondary'}
          onClick={() => {
            this.props.onLayoutChange('cards');
          }}
        >
          <i className="fa fa-th" /> {t('Cards')}
        </Button>
        <Button
          color={layout === 'table' ? 'primary' : 'secondary'}
          onClick={() => {
            this.props.onLayoutChange('table');
          }}
        >
          <i className="fa fa-list" /> {t('Table')}
        </Button>
      </ButtonGroup>
    );
  }
}

const PledgeViewSelectionComponent: React.ComponentType<PledgeViewSelectionProps & PledgeViewSelectionHandlersProps> = compose(
  withLocalization('pledges')
)(PledgeViewSelection);

class PledgeCategoryPage extends React.Component<LProps<Props> & RouterProps, { layout: 'cards' | 'table' }> {
  public state: { layout: 'cards' | 'table' } = {
    layout: 'cards'
  };
  public componentWillMount() {
    const { initializePledgesPage } = this.props;
    initializePledgesPage();
  }

  public renderSelection() {
    const { layout } = this.state;
    return (
      <PledgeViewSelectionComponent layout={layout} onLayoutChange={(newLayout) => this.setState({ layout: newLayout })} />
    );
  }

  public render() {
    const { layout } = this.state;
    return (
      <div className="cc__page__column_content">
        {layout === 'cards' ? (
          <PledgesCards competitionPledgeCategoryID={0} changeComponent={this.renderSelection()} />
        ) : (
          <PledgesTable competitionPledgeCategoryID={0} changeComponent={this.renderSelection()} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: State, ownProps: LProps<RouterProps>): Partial<Props> => ({});
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  initializePledgesPage: actions.initializePledgesPage
}, dispatch);

export default asPage({ requiresCompetitionStart: true, requiresCompetitionVerification: true })(compose(
  withLocalization('blog'),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(PledgeCategoryPage) as React.SFC);
